import { useQuery } from "@tanstack/react-query";
import { getWholesaleEventsMonthService, type EventsWholesaleMonthResponse } from "../services/getWholesaleEventService";

export function useGetWholesaleEventMonth(month: string) {
  return useQuery<EventsWholesaleMonthResponse, Error>({
    queryKey: ["wholesale-events-by-month", month],
    queryFn: () => getWholesaleEventsMonthService(month),
    
  });
}